import { toast } from "react-toastify";

export const emailValidationCheck = (email) => {
  let userEmailRegex = /[a-z0-9]+@[a-z0-9]+\.[a-z]{2,}/g;
  if (email.length >= 6 && userEmailRegex.test(email)) return true;
  return false;
};

export const phoneNumberValidationCheck = (phoneNumber) => {
  let phoneNumberRegex = /^[0-9]{10}$/g;
  return phoneNumberRegex.test(phoneNumber);
};

export const passwordValidationCheck = (password) => {
  let userPasswordRegex =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=.])(?!.*\s).{8,}$/g;
  if (password.length >= 8 && userPasswordRegex.test(password)) return true;
  return false;
};

export const passwordStrengthCheck = (passwordValue) => {
  const strengthChecks = {
    length: 0,
    hasUpperCase: false,
    hasLowerCase: false,
    hasDigit: false,
    hasValidSpecialChar: false,
  };

  strengthChecks.length = passwordValue.length >= 8 ? true : false;
  strengthChecks.hasUpperCase = /[A-Z]+/.test(passwordValue);
  strengthChecks.hasLowerCase = /[a-z]+/.test(passwordValue);
  strengthChecks.hasDigit = /[0-9]+/.test(passwordValue);
  strengthChecks.hasValidSpecialChar = /[@$#*-+]+/.test(passwordValue);

  let verifiedList = Object.values(strengthChecks).filter((value) => value);

  let strength =
    verifiedList.length === 5
      ? "Strong"
      : verifiedList.length >= 2
        ? "Medium"
        : "Weak";

  return {
    progress: `${(verifiedList.length / 5) * 100}%`,
    strength: strength,
  };
};

export const pinValidationCheck = (pin) => {
  let pinRegex = /^[0-9]{4,}$/g;
  return pinRegex.test(pin);
};

export const waba6DigitPinValidation = (pin) => {
  let pinRegex = /^[0-9]{6}$/g;
  return pinRegex.test(pin);
};

export const boolCheck = (val) => {
  if (val === 1) return "Yes";
  else if (val === 0) return "No";
  return "NA";
};

// **********************************
// Sanitations
// **********************************

export const inputUsernameSanitation = (input) => {
  return input
    .replace(/[^a-zA-Z0-9_\s]/g, "")
    .replace(/[\s_]+/g, "_")
    .trim()
    .toLowerCase();
};

export const numbersOnlySanitation = (input) => {
  return input.replace(/[^0-9_\s]/g, "").trim();
};

export const camelCaseToCapitalCase = (text = "") => {
  return (
    text
      // add space before capital letters
      .replace(/([A-Z])/g, " $1")
      // capitalize first letter
      .replace(/^./, (str) => str.toUpperCase())
      .trim()
  );
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.info(`${text} copied successfully!`);
  } catch (error) {
    console.error("Failed to copy:", error);
  }
};
